var stdin_default = {
  panels: [
    {
      index: 0,
      height: 296.6,
      width: 210,
      paperHeader: 49.5,
      paperFooter: 780,
      watermarkOptions: {
        content: "hiPrint",
        rotate: 45
      },
      printElements: [],
      paperNumberLeft: 565.5,
      paperNumberTop: 819
    }
  ]
};
export {
  stdin_default as default
};
